var _sodipodiNamedview, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCatalogue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "211.66789mm",
    height: "162.00685mm",
    viewBox: "0 0 211.66789 162.00685",
    id: "svg1",
    xmlSpace: "preserve",
    inkscapeVersion: "1.3.2 (091e20e, 2023-11-25)",
    sodipodiDocname: "drawing.svg",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "namedview1",
    pagecolor: "#ffffff",
    bordercolor: "#000000",
    borderopacity: 0.25,
    inkscapeShowpageshadow: 2,
    inkscapePageopacity: 0,
    inkscapePagecheckerboard: 0,
    inkscapeDeskcolor: "#d1d1d1",
    "inkscapeDocument-units": "mm",
    inkscapeZoom: 0.11425189,
    inkscapeCx: -1746.1417,
    inkscapeCy: 993.41898,
    "inkscapeWindow-width": 1366,
    "inkscapeWindow-height": 731,
    "inkscapeWindow-x": 0,
    "inkscapeWindow-y": 0,
    "inkscapeWindow-maximized": 1,
    "inkscapeCurrent-layer": "layer1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  })), /*#__PURE__*/React.createElement("g", {
    inkscapeLabel: "Layer 1",
    inkscapeGroupmode: "layer",
    id: "layer1",
    transform: "translate(842.80745,-322.24273)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#0d2c44",
      fillOpacity: 1
    },
    id: "g6",
    transform: "matrix(0.20670573,0,0,0.20670573,-842.80744,297.41283)",
    "inkscapeExport-filename": "catalogue.svg",
    "inkscapeExport-xdpi": 96,
    "inkscapeExport-ydpi": 96
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 808.238,488.008 c -4.42,0 -8.076,-3.578 -8.076,-7.998 0,-4.42 3.5,-7.998 7.904,-7.998 h 0.172 c 4.404,0 7.998,3.578 7.998,7.998 0,4.42 -3.594,7.998 -7.998,7.998 z m 79.976,367.886 c -4.422,0 -8.076,-3.578 -8.076,-7.998 0,-4.42 3.498,-7.998 7.904,-7.998 h 0.172 c 4.404,0 7.996,3.578 7.996,7.998 a 8,8 0 0 1 -7.996,7.998 z M 88.45,248.082 c -4.412,0 -8.076,-3.578 -8.076,-7.998 0,-4.42 3.5,-7.998 7.92,-7.998 h 0.156 c 4.42,0 7.998,3.578 7.998,7.998 0,4.42 -3.576,7.998 -7.998,7.998 z m 31.99,0 c -4.412,0 -8.076,-3.578 -8.076,-7.998 0,-4.42 3.5,-7.998 7.92,-7.998 h 0.156 c 4.42,0 7.998,3.578 7.998,7.998 0,4.42 -3.578,7.998 -7.998,7.998 z m 31.99,0 c -4.412,0 -8.076,-3.578 -8.076,-7.998 0,-4.42 3.5,-7.998 7.92,-7.998 h 0.156 c 4.42,0 7.998,3.578 7.998,7.998 0,4.42 -3.578,7.998 -7.998,7.998 z",
    fill: "",
    id: "path1-5",
    style: {
      fill: "#0d2c44",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 967.706,264.076 H 55.984 a 7.994,7.994 0 0 1 -7.998,-7.998 v -15.994 c 0,-13.23 10.762,-23.992 23.994,-23.992 h 879.732 c 13.23,0 23.992,10.762 23.992,23.992 v 15.994 a 7.994,7.994 0 0 1 -7.998,7.998 z M 63.982,248.082 h 895.726 v -7.998 c 0,-4.334 -3.654,-7.998 -7.996,-7.998 H 71.98 a 8.004,8.004 0 0 0 -7.998,7.998 z",
    fill: "",
    id: "path2-3",
    style: {
      fill: "#0d2c44",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1016.004,344.052 c -0.078,0.008 -0.204,0 -0.312,0 H 8 A 7.998,7.998 0 0 1 1.144,331.938 l 47.984,-79.974 a 8,8 0 0 1 6.858,-3.88 h 911.722 c 2.81,0 5.42,1.474 6.858,3.88 l 47,78.336 a 8,8 0 0 1 -5.562,13.752 z M 22.126,328.056 h 979.444 l -38.394,-63.98 H 60.514 Z",
    fill: "",
    id: "path3-5",
    style: {
      fill: "#0d2c44",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 991.698,392.038 c -5.638,0 -11.136,-1.524 -15.994,-4.366 -9.716,5.686 -22.276,5.686 -31.99,0 -9.716,5.686 -22.276,5.686 -31.99,0 -9.716,5.686 -22.276,5.686 -31.99,0 -9.716,5.686 -22.276,5.686 -31.99,0 -9.716,5.686 -22.276,5.686 -31.99,0 -9.716,5.686 -22.276,5.686 -31.99,0 -9.714,5.686 -22.274,5.686 -31.99,0 -9.716,5.686 -22.276,5.686 -31.99,0 -9.714,5.686 -22.274,5.686 -31.99,0 -9.716,5.686 -22.276,5.686 -31.99,0 -9.714,5.686 -22.274,5.686 -31.99,0 -9.716,5.686 -22.276,5.686 -31.99,0 -9.714,5.686 -22.274,5.686 -31.99,0 -9.716,5.686 -22.276,5.686 -31.99,0 -9.714,5.686 -22.276,5.686 -31.992,0 -9.716,5.686 -22.274,5.686 -31.99,0 -9.714,5.686 -22.274,5.686 -31.99,0 -9.714,5.686 -22.274,5.686 -31.99,0 -9.714,5.686 -22.274,5.686 -31.99,0 -9.714,5.686 -22.274,5.686 -31.99,0 -9.714,5.686 -22.274,5.686 -31.99,0 -9.714,5.686 -22.274,5.686 -31.99,0 -9.714,5.686 -22.274,5.686 -31.99,0 -9.714,5.686 -22.274,5.686 -31.99,0 -9.714,5.686 -22.274,5.686 -31.99,0 -9.714,5.686 -22.274,5.686 -31.99,0 -9.714,5.686 -22.274,5.686 -31.99,0 -9.716,5.686 -22.274,5.686 -31.99,0 -9.716,5.686 -22.274,5.686 -31.99,0 a 31.666,31.666 0 0 1 -15.996,4.366 C 14.348,392.038 0,377.69 0,360.046 v -23.992 a 7.994,7.994 0 0 1 7.998,-7.998 H 1015.69 a 7.992,7.992 0 0 1 7.996,7.998 v 23.992 c 0,17.644 -14.354,31.992 -31.988,31.992 z m -15.994,-22.212 c 1.906,0 3.826,0.678 5.342,2.044 2.998,2.688 6.78,4.172 10.652,4.172 8.826,0 15.996,-7.178 15.996,-15.996 V 344.052 H 15.996 v 15.994 c 0,8.818 7.176,15.996 15.996,15.996 3.874,0 7.654,-1.484 10.652,-4.172 a 7.988,7.988 0 0 1 10.684,0 c 6,5.374 15.308,5.374 21.306,0 a 7.988,7.988 0 0 1 10.684,0 c 5.998,5.374 15.308,5.374 21.306,0 a 7.988,7.988 0 0 1 10.684,0 c 5.998,5.374 15.308,5.374 21.306,0 a 7.988,7.988 0 0 1 10.684,0 c 5.998,5.374 15.308,5.374 21.306,0 a 7.988,7.988 0 0 1 10.684,0 c 5.998,5.374 15.308,5.374 21.306,0 a 7.988,7.988 0 0 1 10.684,0 c 5.998,5.374 15.308,5.374 21.306,0 a 7.988,7.988 0 0 1 10.684,0 c 5.998,5.374 15.308,5.374 21.306,0 a 7.988,7.988 0 0 1 10.684,0 c 5.998,5.374 15.308,5.374 21.306,0 a 7.988,7.988 0 0 1 10.684,0 c 5.998,5.374 15.308,5.374 21.306,0 a 7.988,7.988 0 0 1 10.684,0 c 5.998,5.374 15.308,5.374 21.306,0 a 7.988,7.988 0 0 1 10.684,0 c 6,5.374 15.308,5.374 21.306,0 a 7.988,7.988 0 0 1 10.684,0 c 6,5.374 15.308,5.374 21.306,0 a 7.988,7.988 0 0 1 10.684,0 c 5.998,5.374 15.308,5.374 21.306,0 a 7.988,7.988 0 0 1 10.684,0 c 5.998,5.374 15.308,5.374 21.306,0 a 7.988,7.988 0 0 1 10.684,0 c 3,2.688 6.78,4.172 10.654,4.172 4.96,0 8.538,-2.274 10.654,-4.172 3.052,-2.716 7.654,-2.74 10.684,0 5.998,5.374 15.308,5.374 21.306,0 a 7.988,7.988 0 0 1 10.684,0 c 5.998,5.374 15.308,5.374 21.306,0 a 7.988,7.988 0 0 1 10.684,0 c 5.998,5.374 15.308,5.374 21.306,0 a 7.988,7.988 0 0 1 10.684,0 c 5.998,5.374 15.308,5.374 21.306,0 a 7.988,7.988 0 0 1 10.684,0 c 5.998,5.374 15.308,5.374 21.306,0 a 7.988,7.988 0 0 1 10.684,0 c 5.998,5.374 15.308,5.374 21.306,0 a 7.988,7.988 0 0 1 10.684,0 c 5.998,5.374 15.308,5.374 21.306,0 a 7.988,7.988 0 0 1 10.684,0 c 5.998,5.374 15.308,5.374 21.306,0 a 7.988,7.988 0 0 1 10.684,0 c 5.998,5.374 15.308,5.374 21.306,0 a 7.988,7.988 0 0 1 10.684,0 c 5.998,5.374 15.308,5.374 21.306,0 a 7.988,7.988 0 0 1 10.684,0 c 5.998,5.374 15.306,5.374 21.306,0 a 7.988,7.988 0 0 1 10.684,0 c 5.998,5.374 15.308,5.374 21.306,0 a 7.988,7.988 0 0 1 10.684,0 c 5.998,5.374 15.306,5.374 21.306,0 a 7.988,7.988 0 0 1 10.684,0 c 5.998,5.374 15.308,5.374 21.304,0 a 7.996,7.996 0 0 1 5.35,-2.044 z",
    fill: "",
    id: "path4-6",
    style: {
      fill: "#0d2c44",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 55.984,903.878 a 7.992,7.992 0 0 1 -7.998,-7.996 v -513.31 a 7.994,7.994 0 0 1 7.998,-7.998 7.994,7.994 0 0 1 7.998,7.998 v 513.31 a 7.992,7.992 0 0 1 -7.998,7.996 z m 911.722,0 a 7.992,7.992 0 0 1 -7.998,-7.996 V 384.04 c 0,-4.42 3.578,-7.996 7.998,-7.996 4.42,0 7.998,3.576 7.998,7.996 v 511.844 a 7.994,7.994 0 0 1 -7.998,7.994 z",
    fill: "",
    id: "path5-2",
    style: {
      fill: "#0d2c44",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 967.706,903.878 H 55.984 a 7.992,7.992 0 0 1 -7.998,-7.996 7.994,7.994 0 0 1 7.998,-7.998 h 911.722 a 7.994,7.994 0 0 1 7.998,7.998 c 0,4.42 -3.58,7.996 -7.998,7.996 z M 919.718,775.918 H 775.762 a 7.992,7.992 0 0 1 -7.998,-7.996 V 432.024 a 7.992,7.992 0 0 1 7.998,-7.996 h 143.956 a 7.992,7.992 0 0 1 7.998,7.996 v 335.898 a 7.992,7.992 0 0 1 -7.998,7.996 z M 783.762,759.924 h 127.96 V 440.022 h -127.96 z",
    fill: "",
    id: "path6-9",
    style: {
      fill: "#0d2c44",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 887.73,488.008 h -47.986 c -4.42,0 -7.998,-3.578 -7.998,-7.998 0,-4.42 3.578,-7.998 7.998,-7.998 h 47.986 c 4.42,0 7.996,3.578 7.996,7.998 0,4.42 -3.576,7.998 -7.996,7.998 z m -79.492,47.984 c -4.42,0 -8.076,-3.576 -8.076,-7.996 0,-4.422 3.5,-7.998 7.904,-7.998 h 0.172 a 8.004,8.004 0 0 1 7.998,7.998 8.002,8.002 0 0 1 -7.998,7.996 z m 79.492,0 h -47.986 a 7.992,7.992 0 0 1 -7.998,-7.996 7.994,7.994 0 0 1 7.998,-7.998 h 47.986 a 7.992,7.992 0 0 1 7.996,7.998 7.99,7.99 0 0 1 -7.996,7.996 z m -79.492,47.986 c -4.42,0 -8.076,-3.578 -8.076,-7.998 0,-4.42 3.5,-7.998 7.904,-7.998 h 0.172 c 4.404,0 7.998,3.578 7.998,7.998 0,4.42 -3.594,7.998 -7.998,7.998 z m 79.492,0 h -47.986 c -4.42,0 -7.998,-3.578 -7.998,-7.998 0,-4.42 3.578,-7.998 7.998,-7.998 h 47.986 c 4.42,0 7.996,3.578 7.996,7.998 0,4.42 -3.576,7.998 -7.996,7.998 z m -47.986,63.98 h -31.99 c -4.42,0 -7.996,-3.578 -7.996,-7.998 0,-4.42 3.576,-7.998 7.996,-7.998 h 31.99 c 4.42,0 7.998,3.578 7.998,7.998 0,4.42 -3.578,7.998 -7.998,7.998 z",
    fill: "",
    id: "path7-1",
    style: {
      fill: "#0d2c44",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 855.738,663.954 c -13.228,0 -23.992,-10.762 -23.992,-23.992 0,-13.23 10.764,-23.992 23.992,-23.992 13.23,0 23.994,10.762 23.994,23.992 0,13.23 -10.764,23.992 -23.994,23.992 z m 0,-31.992 c -4.404,0 -7.996,3.594 -7.996,7.998 0,4.404 3.592,7.998 7.996,7.998 4.406,0 7.998,-3.594 7.998,-7.998 0,-4.404 -3.592,-7.998 -7.998,-7.998 z",
    fill: "",
    id: "path8-2",
    style: {
      fill: "#0d2c44",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 887.73,647.958 h -15.996 c -4.42,0 -7.998,-3.578 -7.998,-7.998 0,-4.42 3.578,-7.998 7.998,-7.998 h 15.996 c 4.42,0 7.996,3.578 7.996,7.998 0,4.42 -3.576,7.998 -7.996,7.998 z m 0,63.982 h -31.992 a 7.992,7.992 0 0 1 -7.996,-7.998 7.992,7.992 0 0 1 7.996,-7.998 h 31.992 a 7.992,7.992 0 0 1 7.996,7.998 7.992,7.992 0 0 1 -7.996,7.998 z",
    fill: "",
    id: "path9-7",
    style: {
      fill: "#0d2c44",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 839.744,727.934 c -13.23,0 -23.992,-10.762 -23.992,-23.992 0,-13.23 10.762,-23.992 23.992,-23.992 13.23,0 23.992,10.762 23.992,23.992 0,13.23 -10.762,23.992 -23.992,23.992 z m 0,-31.99 a 8.014,8.014 0 0 0 -7.998,7.998 c 0,4.404 3.594,7.998 7.998,7.998 4.404,0 7.998,-3.594 7.998,-7.998 a 8.014,8.014 0 0 0 -7.998,-7.998 z",
    fill: "",
    id: "path10",
    style: {
      fill: "#0d2c44",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 823.75,711.94 h -15.996 a 7.992,7.992 0 0 1 -7.996,-7.998 7.992,7.992 0 0 1 7.996,-7.998 h 15.996 a 7.992,7.992 0 0 1 7.996,7.998 7.992,7.992 0 0 1 -7.996,7.998 z M 727.78,695.944 H 551.832 a 7.992,7.992 0 0 1 -7.996,-7.998 V 432.024 a 7.99,7.99 0 0 1 7.996,-7.996 H 727.78 a 7.992,7.992 0 0 1 7.998,7.996 v 255.922 a 7.994,7.994 0 0 1 -7.998,7.998 z M 559.83,679.95 H 719.782 V 440.022 H 559.83 Z",
    fill: "",
    id: "path11",
    style: {
      fill: "#a94064",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 679.792,663.954 h -79.974 c -13.23,0 -23.994,-10.762 -23.994,-23.992 0,-13.23 10.764,-23.992 23.994,-23.992 h 79.974 c 13.23,0 23.992,10.762 23.992,23.992 0,13.23 -10.76,23.992 -23.992,23.992 z m -79.974,-31.992 c -4.404,0 -7.998,3.594 -7.998,7.998 0,4.404 3.594,7.998 7.998,7.998 h 79.974 c 4.406,0 7.998,-3.594 7.998,-7.998 0,-4.404 -3.592,-7.998 -7.998,-7.998 z M 727.78,567.982 H 551.832 a 7.992,7.992 0 0 1 -7.996,-7.998 7.99,7.99 0 0 1 7.996,-7.996 H 727.78 a 7.992,7.992 0 0 1 7.998,7.996 7.994,7.994 0 0 1 -7.998,7.998 z",
    fill: "",
    id: "path12",
    style: {
      fill: "#a94064",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 727.78,567.982 a 8.012,8.012 0 0 1 -6.404,-3.202 l -41.582,-55.446 -41.58,55.446 a 8.008,8.008 0 0 1 -11.202,1.61 8.02,8.02 0 0 1 -1.608,-11.202 l 47.984,-63.98 c 3.032,-4.03 9.78,-4.03 12.808,0 l 47.986,63.98 a 8.02,8.02 0 0 1 -1.61,11.202 7.966,7.966 0 0 1 -4.792,1.592 z",
    fill: "",
    id: "path13",
    style: {
      fill: "#a94064",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 583.822,567.982 a 8.03,8.03 0 0 1 -4.998,-1.748 8.012,8.012 0 0 1 -1.25,-11.248 L 609.564,515 a 7.988,7.988 0 0 1 6.248,-3 c 2.438,0 4.734,1.11 6.248,3.008 l 23.744,29.686 a 8.012,8.012 0 0 1 -1.25,11.246 8.02,8.02 0 0 1 -11.246,-1.25 l -17.496,-21.882 -25.742,32.178 a 7.994,7.994 0 0 1 -6.248,2.996 z m 15.996,-63.98 c -13.23,0 -23.994,-10.762 -23.994,-23.992 0,-13.23 10.764,-23.992 23.994,-23.992 13.23,0 23.992,10.762 23.992,23.992 0,13.23 -10.762,23.992 -23.992,23.992 z m 0,-31.99 c -4.404,0 -7.998,3.586 -7.998,7.998 0,4.412 3.594,7.998 7.998,7.998 4.404,0 7.998,-3.586 7.998,-7.998 0,-4.412 -3.594,-7.998 -7.998,-7.998 z m 31.99,127.96 h -47.986 a 7.992,7.992 0 0 1 -7.998,-7.996 7.994,7.994 0 0 1 7.998,-7.998 h 47.986 a 7.992,7.992 0 0 1 7.996,7.998 7.99,7.99 0 0 1 -7.996,7.996 z m 63.982,0 h -23.992 a 7.992,7.992 0 0 1 -7.998,-7.996 7.992,7.992 0 0 1 7.998,-7.998 h 23.992 a 7.992,7.992 0 0 1 7.996,7.998 7.992,7.992 0 0 1 -7.996,7.996 z m -79.978,63.982 a 7.99,7.99 0 0 1 -7.996,-7.996 v -31.992 a 7.99,7.99 0 0 1 7.996,-7.996 7.992,7.992 0 0 1 7.998,7.996 v 31.992 a 7.992,7.992 0 0 1 -7.998,7.996 z M 727.78,871.89 a 7.962,7.962 0 0 1 -6.388,-3.204 l -41.598,-55.436 -41.596,55.436 a 7.936,7.936 0 0 1 -11.186,1.594 7.966,7.966 0 0 1 -1.592,-11.184 l 47.968,-63.98 c 3.032,-4.032 9.78,-4.032 12.808,0 l 47.97,63.98 a 7.966,7.966 0 0 1 -1.594,11.184 7.856,7.856 0 0 1 -4.792,1.61 z",
    fill: "",
    id: "path14",
    style: {
      fill: "#a94064",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 583.822,871.89 a 8.054,8.054 0 0 1 -4.998,-1.75 8.01,8.01 0 0 1 -1.25,-11.246 l 31.99,-39.988 a 8.006,8.006 0 0 1 12.496,0 l 23.744,29.694 a 8.014,8.014 0 0 1 -1.25,11.248 8.01,8.01 0 0 1 -11.246,-1.25 l -17.496,-21.884 -25.742,32.178 a 7.996,7.996 0 0 1 -6.248,2.998 z m 15.996,-63.98 c -13.23,0 -23.994,-10.764 -23.994,-23.994 0,-13.228 10.764,-23.992 23.994,-23.992 13.23,0 23.992,10.764 23.992,23.992 0,13.23 -10.762,23.994 -23.992,23.994 z m 0,-31.992 a 8.014,8.014 0 0 0 -7.998,7.998 c 0,4.406 3.594,7.998 7.998,7.998 4.404,0 7.998,-3.592 7.998,-7.998 a 8.014,8.014 0 0 0 -7.998,-7.998 z m -47.986,95.972 a 7.992,7.992 0 0 1 -7.996,-7.998 v -127.96 a 7.992,7.992 0 0 1 7.996,-7.998 7.994,7.994 0 0 1 7.998,7.998 v 127.96 a 7.994,7.994 0 0 1 -7.998,7.998 z",
    fill: "",
    id: "path15",
    style: {
      fill: "#a94064",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 727.78,743.93 H 551.832 c -4.42,0 -7.996,-3.578 -7.996,-7.998 0,-4.42 3.576,-7.998 7.996,-7.998 H 727.78 c 4.42,0 7.998,3.578 7.998,7.998 0,4.42 -3.578,7.998 -7.998,7.998 z",
    fill: "",
    id: "path16",
    style: {
      fill: "#a94064",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 727.78,871.89 a 7.994,7.994 0 0 1 -7.998,-7.998 v -127.96 a 7.994,7.994 0 0 1 7.998,-7.998 7.994,7.994 0 0 1 7.998,7.998 v 127.96 a 7.994,7.994 0 0 1 -7.998,7.998 z",
    fill: "",
    id: "path17",
    style: {
      fill: "#a94064",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 503.846,695.944 H 327.9 a 7.994,7.994 0 0 1 -7.998,-7.998 V 432.024 a 7.992,7.992 0 0 1 7.998,-7.996 h 175.946 a 7.992,7.992 0 0 1 7.998,7.996 v 255.922 a 7.994,7.994 0 0 1 -7.998,7.998 z M 335.898,679.95 H 495.85 V 440.022 H 335.898 Z",
    fill: "",
    id: "path18",
    style: {
      fill: "#a94064",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 455.862,663.954 h -79.976 c -13.23,0 -23.992,-10.762 -23.992,-23.992 0,-13.23 10.762,-23.992 23.992,-23.992 h 79.976 c 13.23,0 23.992,10.762 23.992,23.992 0,13.23 -10.764,23.992 -23.992,23.992 z m -79.976,-31.992 c -4.412,0 -7.998,3.594 -7.998,7.998 0,4.404 3.586,7.998 7.998,7.998 h 79.976 c 4.414,0 7.998,-3.594 7.998,-7.998 0,-4.404 -3.584,-7.998 -7.998,-7.998 z m 127.96,-63.98 H 327.9 a 7.994,7.994 0 0 1 -7.998,-7.998 7.992,7.992 0 0 1 7.998,-7.996 h 175.946 a 7.992,7.992 0 0 1 7.998,7.996 7.994,7.994 0 0 1 -7.998,7.998 z",
    fill: "",
    id: "path19",
    style: {
      fill: "#a94064",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 503.854,567.982 a 7.98,7.98 0 0 1 -6.404,-3.202 l -41.588,-55.446 -41.588,55.446 a 7.9952001,7.9952001 0 1 1 -12.794,-9.592 l 47.986,-63.98 c 3.014,-4.03 9.778,-4.03 12.792,0 l 47.986,63.98 a 7.996,7.996 0 0 1 -6.39,12.794 z",
    fill: "",
    id: "path20",
    style: {
      fill: "#a94064",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 359.882,567.982 a 8.03,8.03 0 0 1 -4.992,-1.748 8.014,8.014 0 0 1 -1.25,-11.248 L 385.63,515 a 8.008,8.008 0 0 1 6.248,-3 c 2.428,0 4.726,1.11 6.248,3.008 l 23.744,29.686 a 8.006,8.006 0 0 1 -1.258,11.246 c -3.444,2.75 -8.498,2.188 -11.238,-1.25 l -17.496,-21.882 -25.742,32.178 a 8,8 0 0 1 -6.254,2.996 z m 16.004,-63.98 c -13.23,0 -23.992,-10.762 -23.992,-23.992 0,-13.23 10.762,-23.992 23.992,-23.992 13.23,0 23.992,10.762 23.992,23.992 0,13.23 -10.762,23.992 -23.992,23.992 z m 0,-31.99 c -4.412,0 -7.998,3.586 -7.998,7.998 0,4.412 3.586,7.998 7.998,7.998 4.412,0 7.998,-3.586 7.998,-7.998 0,-4.412 -3.586,-7.998 -7.998,-7.998 z m 31.99,127.96 H 359.89 a 7.992,7.992 0 0 1 -7.998,-7.996 7.992,7.992 0 0 1 7.998,-7.998 h 47.986 a 7.994,7.994 0 0 1 7.998,7.998 7.992,7.992 0 0 1 -7.998,7.996 z m 63.98,0 h -23.992 a 7.992,7.992 0 0 1 -7.998,-7.996 7.992,7.992 0 0 1 7.998,-7.998 h 23.992 a 7.994,7.994 0 0 1 7.998,7.998 7.992,7.992 0 0 1 -7.998,7.996 z m -79.976,63.982 a 7.992,7.992 0 0 1 -7.998,-7.996 v -31.992 c 0,-4.42 3.576,-7.996 7.998,-7.996 4.422,0 7.998,3.576 7.998,7.996 v 31.992 a 7.992,7.992 0 0 1 -7.998,7.996 z M 503.854,871.89 a 7.992,7.992 0 0 1 -6.404,-3.204 l -41.588,-55.436 -41.588,55.436 c -2.656,3.532 -7.678,4.282 -11.2,1.594 a 7.984,7.984 0 0 1 -1.594,-11.184 l 47.986,-63.98 c 3.014,-4.032 9.778,-4.032 12.792,0 l 47.986,63.98 a 7.986,7.986 0 0 1 -1.594,11.184 7.868,7.868 0 0 1 -4.796,1.61 z",
    fill: "",
    id: "path21",
    style: {
      fill: "#a94064",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 359.882,871.89 a 8.02,8.02 0 0 1 -4.992,-1.75 8.012,8.012 0 0 1 -1.25,-11.246 l 31.99,-39.988 a 8.032,8.032 0 0 1 6.248,-3 c 2.428,0 4.726,1.11 6.248,3 L 421.87,848.6 a 8.008,8.008 0 0 1 -1.258,11.248 c -3.444,2.748 -8.498,2.186 -11.238,-1.25 l -17.496,-21.884 -25.742,32.178 a 8,8 0 0 1 -6.254,2.998 z m 16.004,-63.98 c -13.23,0 -23.992,-10.764 -23.992,-23.994 0,-13.228 10.762,-23.992 23.992,-23.992 13.23,0 23.992,10.764 23.992,23.992 0,13.23 -10.762,23.994 -23.992,23.994 z m 0,-31.992 a 8.01,8.01 0 0 0 -7.998,7.998 c 0,4.406 3.586,7.998 7.998,7.998 4.412,0 7.998,-3.592 7.998,-7.998 a 8.01,8.01 0 0 0 -7.998,-7.998 z M 327.9,871.89 a 7.994,7.994 0 0 1 -7.998,-7.998 v -127.96 c 0,-4.42 3.576,-7.998 7.998,-7.998 4.422,0 7.998,3.578 7.998,7.998 v 127.96 a 7.994,7.994 0 0 1 -7.998,7.998 z",
    fill: "",
    id: "path22",
    style: {
      fill: "#a94064",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 503.846,743.93 H 327.9 c -4.42,0 -7.998,-3.578 -7.998,-7.998 0,-4.42 3.576,-7.998 7.998,-7.998 h 175.946 c 4.42,0 7.998,3.578 7.998,7.998 0,4.42 -3.578,7.998 -7.998,7.998 z",
    fill: "",
    id: "path23",
    style: {
      fill: "#a94064",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 503.846,871.89 a 7.994,7.994 0 0 1 -7.998,-7.998 v -127.96 a 7.994,7.994 0 0 1 7.998,-7.998 7.994,7.994 0 0 1 7.998,7.998 v 127.96 a 7.994,7.994 0 0 1 -7.998,7.998 z",
    fill: "",
    id: "path24",
    style: {
      fill: "#a94064",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 279.916,695.944 H 103.97 a 7.992,7.992 0 0 1 -7.998,-7.998 V 432.024 a 7.992,7.992 0 0 1 7.998,-7.996 h 175.946 a 7.992,7.992 0 0 1 7.998,7.996 v 255.922 a 7.994,7.994 0 0 1 -7.998,7.998 z M 111.966,679.95 h 159.95 V 440.022 h -159.95 z",
    fill: "",
    id: "path25",
    style: {
      fill: "#a94064",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 231.93,663.954 h -79.976 c -13.23,0 -23.992,-10.762 -23.992,-23.992 0,-13.23 10.762,-23.992 23.992,-23.992 h 79.976 c 13.23,0 23.994,10.762 23.994,23.992 0,13.23 -10.764,23.992 -23.994,23.992 z m -79.976,-31.992 c -4.412,0 -7.998,3.594 -7.998,7.998 0,4.404 3.586,7.998 7.998,7.998 h 79.976 c 4.414,0 7.998,-3.594 7.998,-7.998 0,-4.404 -3.584,-7.998 -7.998,-7.998 z m 127.962,-63.98 H 103.97 a 7.992,7.992 0 0 1 -7.998,-7.998 7.992,7.992 0 0 1 7.998,-7.996 h 175.946 a 7.992,7.992 0 0 1 7.998,7.996 7.994,7.994 0 0 1 -7.998,7.998 z",
    fill: "",
    id: "path26",
    style: {
      fill: "#a94064",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 279.922,567.982 a 7.982,7.982 0 0 1 -6.404,-3.202 l -41.588,-55.446 -41.59,55.448 a 7.99,7.99 0 0 1 -11.192,1.61 7.998,7.998 0 0 1 -1.602,-11.202 l 47.986,-63.98 c 3.014,-4.03 9.778,-4.03 12.792,0 l 47.986,63.98 a 7.994,7.994 0 0 1 -6.388,12.792 z",
    fill: "",
    id: "path27",
    style: {
      fill: "#a94064",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 135.952,567.982 a 8.02,8.02 0 0 1 -4.99,-1.748 8.014,8.014 0 0 1 -1.25,-11.248 L 161.702,515 a 8.008,8.008 0 0 1 6.248,-3 c 2.428,0 4.726,1.11 6.248,3.008 l 23.744,29.686 a 8.006,8.006 0 0 1 -1.258,11.246 8.012,8.012 0 0 1 -11.238,-1.25 l -17.496,-21.882 -25.742,32.178 a 8.012,8.012 0 0 1 -6.256,2.996 z m 16.002,-63.98 c -13.23,0 -23.992,-10.762 -23.992,-23.992 0,-13.23 10.762,-23.992 23.992,-23.992 13.23,0 23.992,10.762 23.992,23.992 0,13.23 -10.762,23.992 -23.992,23.992 z m 0,-31.99 c -4.412,0 -7.998,3.586 -7.998,7.998 0,4.412 3.586,7.998 7.998,7.998 4.414,0 7.998,-3.586 7.998,-7.998 0,-4.412 -3.584,-7.998 -7.998,-7.998 z m 31.99,127.96 h -47.986 a 7.992,7.992 0 0 1 -7.998,-7.996 7.992,7.992 0 0 1 7.998,-7.998 h 47.986 a 7.994,7.994 0 0 1 7.998,7.998 7.992,7.992 0 0 1 -7.998,7.996 z m 63.98,0 h -23.992 a 7.992,7.992 0 0 1 -7.998,-7.996 7.994,7.994 0 0 1 7.998,-7.998 h 23.992 a 7.994,7.994 0 0 1 7.998,7.998 7.992,7.992 0 0 1 -7.998,7.996 z m -79.974,63.982 a 7.992,7.992 0 0 1 -7.998,-7.996 v -31.992 c 0,-4.42 3.576,-7.996 7.998,-7.996 4.422,0 7.998,3.576 7.998,7.996 v 31.992 a 7.996,7.996 0 0 1 -7.998,7.996 z M 279.922,871.89 a 7.996,7.996 0 0 1 -6.404,-3.204 L 231.93,813.25 190.34,868.688 c -2.64,3.532 -7.678,4.282 -11.2,1.594 a 7.986,7.986 0 0 1 -1.594,-11.184 l 47.986,-63.98 c 3.014,-4.032 9.778,-4.032 12.792,0 l 47.986,63.98 a 7.984,7.984 0 0 1 -1.594,11.184 7.864,7.864 0 0 1 -4.794,1.608 z",
    fill: "",
    id: "path28",
    style: {
      fill: "#a94064",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 135.952,871.89 a 8.012,8.012 0 0 1 -4.99,-1.75 8.012,8.012 0 0 1 -1.25,-11.246 l 31.99,-39.988 a 8.032,8.032 0 0 1 6.248,-3 c 2.428,0 4.726,1.11 6.248,3 L 197.94,848.6 a 8.008,8.008 0 0 1 -1.258,11.248 8.016,8.016 0 0 1 -11.238,-1.25 l -17.496,-21.884 -25.742,32.178 a 8.006,8.006 0 0 1 -6.254,2.998 z m 16.002,-63.98 c -13.23,0 -23.992,-10.764 -23.992,-23.994 0,-13.228 10.762,-23.992 23.992,-23.992 13.23,0 23.992,10.764 23.992,23.992 0,13.23 -10.762,23.994 -23.992,23.994 z m 0,-31.992 a 8.01,8.01 0 0 0 -7.998,7.998 8.008,8.008 0 0 0 7.998,7.998 8.008,8.008 0 0 0 7.998,-7.998 8.008,8.008 0 0 0 -7.998,-7.998 z M 103.97,871.89 a 7.994,7.994 0 0 1 -7.998,-7.998 v -127.96 a 7.994,7.994 0 0 1 7.998,-7.998 7.994,7.994 0 0 1 7.998,7.998 v 127.96 a 7.996,7.996 0 0 1 -7.998,7.998 z",
    fill: "",
    id: "path29",
    style: {
      fill: "#a94064",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 279.916,743.93 H 103.97 c -4.422,0 -7.998,-3.578 -7.998,-7.998 0,-4.42 3.576,-7.998 7.998,-7.998 h 175.946 c 4.42,0 7.998,3.578 7.998,7.998 0,4.42 -3.58,7.998 -7.998,7.998 z",
    fill: "",
    id: "path30",
    style: {
      fill: "#a94064",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 279.916,871.89 a 7.994,7.994 0 0 1 -7.998,-7.998 v -127.96 c 0,-4.42 3.578,-7.998 7.998,-7.998 4.42,0 7.998,3.578 7.998,7.998 v 127.96 c 0,4.42 -3.58,7.998 -7.998,7.998 z",
    fill: "",
    id: "path31",
    style: {
      fill: "#a94064",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 855.738,855.894 h -47.984 c -4.42,0 -7.996,-3.578 -7.996,-7.998 0,-4.42 3.576,-7.998 7.996,-7.998 h 47.984 c 4.422,0 7.998,3.578 7.998,7.998 0,4.42 -3.576,7.998 -7.998,7.998 z",
    fill: "",
    id: "path32",
    style: {
      fill: "#0d2c44",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 775.764,871.89 a 7.994,7.994 0 0 1 -7.998,-7.998 v -47.986 c 0,-4.42 3.578,-7.996 7.998,-7.996 4.42,0 7.998,3.576 7.998,7.996 v 47.986 a 7.994,7.994 0 0 1 -7.998,7.998 z",
    fill: "",
    id: "path33",
    style: {
      fill: "#0d2c44",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 919.718,823.904 H 775.762 a 7.994,7.994 0 0 1 -7.998,-7.998 7.992,7.992 0 0 1 7.998,-7.996 h 143.956 a 7.992,7.992 0 0 1 7.998,7.996 7.992,7.992 0 0 1 -7.998,7.998 z",
    fill: "",
    id: "path34",
    style: {
      fill: "#0d2c44",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 919.718,871.89 a 7.992,7.992 0 0 1 -7.996,-7.998 v -47.986 a 7.99,7.99 0 0 1 7.996,-7.996 7.992,7.992 0 0 1 7.998,7.996 v 47.986 a 7.994,7.994 0 0 1 -7.998,7.998 z",
    fill: "",
    id: "path35",
    style: {
      fill: "#0d2c44",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 791.76,200.096 H 247.924 a 7.994,7.994 0 0 1 -7.998,-7.998 v -63.98 a 7.992,7.992 0 0 1 7.998,-7.996 H 791.76 a 7.992,7.992 0 0 1 7.998,7.996 v 63.98 a 7.994,7.994 0 0 1 -7.998,7.998 z M 255.922,184.102 H 783.76 V 136.116 H 255.922 Z",
    fill: "",
    id: "path36",
    style: {
      fill: "#0d2c44",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 311.906,232.086 a 7.994,7.994 0 0 1 -7.998,-7.998 v -31.99 c 0,-4.42 3.578,-7.996 7.998,-7.996 4.42,0 7.998,3.576 7.998,7.996 v 31.99 a 7.994,7.994 0 0 1 -7.998,7.998 z m 415.874,0 a 7.992,7.992 0 0 1 -7.998,-7.998 v -31.99 a 7.992,7.992 0 0 1 7.998,-7.996 7.992,7.992 0 0 1 7.998,7.996 v 31.99 a 7.994,7.994 0 0 1 -7.998,7.998 z",
    fill: "",
    id: "path37",
    style: {
      fill: "#0d2c44",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 727.78,168.106 H 295.91 a 7.994,7.994 0 0 1 -7.998,-7.998 7.992,7.992 0 0 1 7.998,-7.996 h 431.87 a 7.992,7.992 0 0 1 7.998,7.996 7.994,7.994 0 0 1 -7.998,7.998 z",
    fill: "",
    id: "path38",
    style: {
      fill: "#0d2c44",
      fillOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatalogue);
export default __webpack_public_path__ + "static/media/catalogue.d2e927e29775d001c89dfcdd280ecdb5.svg";
export { ForwardRef as ReactComponent };